// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/LogoutDialog.css */
.logout-dialog-text {
  font-size: 16px;
  margin-bottom: 20px;
  color: #333;
}

.logout-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.logout-option-btn {
  padding: 15px;
  text-align: left;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.logout-option-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.logout-option-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.logout-option-content strong {
  font-size: 15px;
}

.logout-option-content small {
  font-size: 13px;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/logoutDialog/logoutDialog.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* src/components/LogoutDialog.css */\n.logout-dialog-text {\n  font-size: 16px;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.logout-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.logout-option-btn {\n  padding: 15px;\n  text-align: left;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.logout-option-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.logout-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.logout-option-content strong {\n  font-size: 15px;\n}\n\n.logout-option-content small {\n  font-size: 13px;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
